import type { ApolloError } from '@apollo/client';
import { useTypedQuery } from '../lib/generated/zeus/apollo';
import { activeRecord } from '../lib/graphql/common/queries';
import { genericScalars } from '../lib/graphql/helpers';
import { teamRoleAssignmentSelector } from './selectors/team';

type QueryTeamRoleAssignmentParams = {
  /**
   * Type of team for the assigned role.
   */
  readonly teamType?: string;
  /**
   * Team role name for the assignment.
   */
  readonly teamRoleName?: string;
} & { readonly onError: (e: ApolloError) => void };

export const useQueryTeamRoleAssignmentsQueryName =
  'useQueryTeamRoleAssignments';

/**
 * Provides GraphQL query to fetch team role assignments based on the provided parameters.
 * @param params used to query the team role assignment.
 * @returns custom hook that provides GraphQL query to team role assignments
 */
const useQueryTeamRoleAssignments = (params: QueryTeamRoleAssignmentParams) => {
  const teamFilter = () => {
    if (params.teamType !== undefined) {
      return {
        team: {
          team_type: {
            _eq: params.teamType,
          },
        },
      };
    }

    return {};
  };

  return useTypedQuery(
    {
      team_role_assignment: [
        {
          where: {
            ...activeRecord,
            ...teamFilter(),
            team_role: {
              name: {
                _eq: params.teamRoleName,
              },
            },
          },
        },
        teamRoleAssignmentSelector,
      ],
    },
    {
      scalars: genericScalars,
      apolloOptions: { onError: params.onError },
      operationOptions: {
        operationName: useQueryTeamRoleAssignmentsQueryName,
      },
    }
  );
};

export default useQueryTeamRoleAssignments;
